// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { firstValueFrom } from "rxjs";

import { ControlsOf } from "@box/angular/types/controls-of";
import {
  getOrganizationById,
  OrganizationService,
} from "@box/common/admin-console/abstractions/organization/organization.service.abstraction";
import { PolicyType } from "@box/common/admin-console/enums";
import { MasterPasswordPolicyOptions } from "@box/common/admin-console/models/domain/master-password-policy-options";
import { AccountService } from "@box/common/auth/abstractions/account.service";
import { getUserId } from "@box/common/auth/services/account.service";
import { I18nService } from "@box/common/platform/abstractions/i18n.service";
import { Utils } from "@box/common/platform/misc/utils";

import { SharedModule } from "../../../../shared";
import { BasePolicyEditDefinition, BasePolicyEditComponent } from "../base-policy-edit.component";

export class MasterPasswordPolicy extends BasePolicyEditDefinition {
  name = "masterPassPolicyTitle";
  description = "masterPassPolicyDesc";
  type = PolicyType.MasterPassword;
  component = MasterPasswordPolicyComponent;
}

@Component({
  selector: "master-password-policy-edit",
  templateUrl: "master-password.component.html",
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MasterPasswordPolicyComponent extends BasePolicyEditComponent implements OnInit {
  MinPasswordLength = Utils.minimumPasswordLength;
  MaxPasswordLength = Utils.maximumPasswordLength;

  data: FormGroup<ControlsOf<MasterPasswordPolicyOptions>> = this.formBuilder.group({
    minComplexity: [null],
    minLength: [
      this.MinPasswordLength,
      [Validators.min(Utils.minimumPasswordLength), Validators.max(this.MaxPasswordLength)],
    ],
    requireUpper: [false],
    requireLower: [false],
    requireNumbers: [false],
    requireSpecial: [false],
    enforceOnLogin: [false],
  });

  passwordScores: { name: string; value: number }[];
  showKeyConnectorInfo = false;

  constructor(
    private formBuilder: FormBuilder,
    i18nService: I18nService,
    private organizationService: OrganizationService,
    private accountService: AccountService,
  ) {
    super();

    this.passwordScores = [
      { name: "-- " + i18nService.t("select") + " --", value: null },
      { name: i18nService.t("weak") + " (0)", value: 0 },
      { name: i18nService.t("weak") + " (1)", value: 1 },
      { name: i18nService.t("weak") + " (2)", value: 2 },
      { name: i18nService.t("good") + " (3)", value: 3 },
      { name: i18nService.t("strong") + " (4)", value: 4 },
    ];
  }

  async ngOnInit() {
    super.ngOnInit();
    const userId = await firstValueFrom(getUserId(this.accountService.activeAccount$));
    const organization = await firstValueFrom(
      this.organizationService
        .organizations$(userId)
        .pipe(getOrganizationById(this.policyResponse.organizationId)),
    );
    this.showKeyConnectorInfo = organization.keyConnectorEnabled;
  }
}
